import "./KBreadcrumbs.scss";
import Themeable from "vuetify/lib/mixins/themeable";
import {
	VBreadcrumbs,
	VBreadcrumbsItem,
	VIcon
} from "vuetify/lib";

export default {
	name: "KBreadcrumbs",

	mixins: [ Themeable ],

	props: {
		maxMobileBreadcrumbs: {
			default: 2,
			type: Number
		}
	},

	computed: {
		isAuthenticated() {
			return this.$store.getters["auth/isAuthenticated"];
		},

		breadcrumbs() {
			return this.$store.state.breadcrumbs.breadcrumbs;
		},

		breadcrumbDetails() {
			return this.$store.state.breadcrumbs.details;
		},

		currentBreadcrumb() {
			return this.$store.getters["breadcrumbs/current"];
		},

		displayedBreadcrumbs() {
			if ( this.$vuetify.breakpoint.smAndUp ) {
				return this.breadcrumbs;
			}

			return this.breadcrumbs.slice( -this.maxMobileBreadcrumbs );
		}
	},

	render() {
		if ( !this.isAuthenticated ) {
			return;
		}

		return <VBreadcrumbs
			class="pl-0 pr-0 py-2"
			items={this.displayedBreadcrumbs}
			scopedSlots={{
				item: props =>
					<VBreadcrumbsItem
						disabled={props.item.text === this.currentBreadcrumb.text}
						exact
						key={`breadcrumb-${props.item.text}`}
						ripple
						to={props.item.to}
					>
						{props.item.text}

						{this.breadcrumbDetails
							&& props.item.text === this.currentBreadcrumb.text
							&& this.$vuetify.breakpoint.smAndUp
							&& <span class="text-caption pl-1 pr-1">({this.breadcrumbDetails})</span>
						}
					</VBreadcrumbsItem>
			}}
		>
			<VIcon slot="divider">chevron_right</VIcon>
		</VBreadcrumbs>;
	}
};
